export const enum ProspectStatus {
  Favorite = 0,
  Active = 1,
  Deactivated = 2,
  FirstCallFail = 3,
  Lead = 4,
  Customer = 5,
  Frozen = 6
}

export const enum SalesCallMethods {
  InPerson = 1,
  PhoneInbound,
  PhoneOutbound
}

export const enum BusinessTypes {
  Dealer = 1,
  SubDealer,
  DealerDistributor,
  Distributor
}

export const enum BusinessEntityTypes {
  Dealer = 1,
  Distributor,
  DealerDistributor,
  SubDealer,
  CompanyStore,
  ProjectServiceProvider,
  Employee,
  InterCompany,
  Marina,
  OEM,
  Poly,
  CashRetail,
  Shoreline,
  InformationalBusiness,
  PartsInstaller
}

export const enum LoadType {
  Truck = 1,
  CustomerPickup,
  Ltl,
  EmployeeDelivery
}

export const enum FinancialType {
  Shipments = 1,
  Preseason,
  PreseasonEstimate,
  PreseasonRevised
}

export const enum OrderStatus {
  None,
  OpenOrder,
  Delivered,
  Invoiced,
  Cancelled
}

export const OrderStatusHash: Record<number, string> = {
  0: 'None',
  1: 'Open Order',
  2: 'Delivered',
  3: 'Invoiced',
  4: 'Cancelled'
};

export const enum PreseasonGoalType {
  Dynamic = 1,
  Static
}

export const enum ShoreMasterDepartment {
  IT = 1,
  Sales,
  Finance,
  Marketing,
  Logistics,
  Operations
}

export const enum LogisticsFileTypes {
  Photo = 1,
  CarrierInvoice,
  BillOfLading,
  CoverSheet,
  LoadingPickList,
  PackagingPickList,
  VendorDirectItems,
  BackOrderItems,
  Unknown
}
